import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchExperienceTripsDtl } from "../services/ExperienceTripsDtl";
import { API_BASE } from "../api/apiConfig";

const ExperienceTripsDtlbanner = () => {
  const { id } = useParams();
  const [ExperienceTripsDtldata, setExperienceTripsDtldata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchExperienceTripsDtl(decodeURIComponent(id));

      if (res?.data) {
         setExperienceTripsDtldata(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);


  // Modal
  const [open, setOpen] = useState(false);

  
const [openDay, setOpenDay] = useState(1);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!ExperienceTripsDtldata) return <p className="text-center py-10">No Data found</p>;

  return (
      
      <>

      <section className="relative md:hidden">
      <div className="relative h-[280px]">
        <img
          alt={ExperienceTripsDtldata?.city}
          className="absolute inset-0 w-full h-full object-cover"
          src={
            ExperienceTripsDtldata?.images
              ? `${API_BASE}${ExperienceTripsDtldata.images}`
              : `${API_BASE}default.jpg`
          }
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/70" />
        <div className="absolute top-0 left-0 right-0 p-4 flex items-center justify-between z-10">
          <a href="/ExperienceTrips" className="h-10 w-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-left h-5 w-5 text-white"
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
          </a>
          <a href="https://wa.me/918920866123" className="h-10 w-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-share2 h-5 w-5 text-white"
            >
              <circle cx={18} cy={5} r={3} />
              <circle cx={6} cy={12} r={3} />
              <circle cx={18} cy={19} r={3} />
              <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
              <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
            </svg>
          </a>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full text-[11px] font-medium text-white">
              {ExperienceTripsDtldata?.spots} spots left
            </span>
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-white/95 backdrop-blur-sm rounded-full text-[11px] font-medium text-slate-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-lightbulb h-3 w-3 text-primary"
              >
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                <path d="M9 18h6" />
                <path d="M10 22h4" />
              </svg>
              {ExperienceTripsDtldata?.tage}
            </span>
          </div>
          <h1 className="text-xl font-bold text-white leading-tight mb-1">
            {ExperienceTripsDtldata?.name}
          </h1>
          <div className="flex items-center gap-1.5 text-white/80 text-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-map-pin h-3.5 w-3.5"
            >
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
              <circle cx={12} cy={10} r={3} />
            </svg>
            <span>Leh, Ladakh</span>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className="px-4 py-3 flex items-center justify-between border-b border-slate-100">
          <div className="flex items-center gap-4 text-sm text-slate-600">
            <span className="flex items-center gap-1.5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar h-4 w-4 text-primary"
              >
                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                <line x1={16} x2={16} y1={2} y2={6} />
                <line x1={8} x2={8} y1={2} y2={6} />
                <line x1={3} x2={21} y1={10} y2={10} />
              </svg>
              {new Date(
                    ExperienceTripsDtldata?.expdate && ExperienceTripsDtldata?.expdate !== "null"
                      ? ExperienceTripsDtldata.expdate
                      : new Date()
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
            </span>
            <span className="flex items-center gap-1.5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-clock h-4 w-4 text-primary"
              >
                <circle cx={12} cy={12} r={10} />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              {ExperienceTripsDtldata?.no_of_days} Days / {ExperienceTripsDtldata?.duration}
            </span>
          </div>
          <span className="flex items-center gap-1.5 text-sm text-slate-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users h-4 w-4 text-primary"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            12
          </span>
        </div>

  {ExperienceTripsDtldata.local_experts_details && ExperienceTripsDtldata.local_experts_details.length > 0 && (
        <div className="m-4 p-3 bg-gradient-to-r from-primary/5 to-primary/10 rounded-2xl border border-primary/10 cursor-pointer active:bg-primary/15 transition-colors" onClick={() => setOpen(true)}>
          <p className="text-[10px] uppercase tracking-wider text-primary font-semibold mb-2">
            Your Trip Host
          </p>
          <div className="flex items-stretch gap-3">
            <div className="relative w-24 h-28 flex-shrink-0 rounded-xl overflow-hidden shadow-lg">
              <img
                alt={ExperienceTripsDtldata.local_experts_details[0].name}
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0,
                  color: "transparent"
                }}
                src={`${API_BASE}/${ExperienceTripsDtldata.local_experts_details[0].profile_image}`}
              />
              <div className="absolute bottom-1.5 right-1.5 h-5 w-5 bg-primary rounded-full flex items-center justify-center shadow-md">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-check h-3 w-3 text-white"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </div>
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-center py-1">
              <p className="text-base font-bold text-slate-900 mb-0.5">
                {ExperienceTripsDtldata.local_experts_details[0].name}
              </p>
              <p className="text-xs text-slate-500 mb-1.5 line-clamp-2"
                dangerouslySetInnerHTML={{
                  __html: ExperienceTripsDtldata.local_experts_details[0].about
                }}>
              </p>
              <div className="flex items-center gap-1 text-slate-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-3 w-3 text-primary"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx={12} cy={10} r={3} />
                </svg>
                <span className="text-[11px]">{ExperienceTripsDtldata.local_experts_details[0].city}, {ExperienceTripsDtldata.local_experts_details[0].state_name}</span>
              </div>
              <p className="text-[10px] text-primary mt-1.5 font-medium">
                Tap to view profile
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-right h-5 w-5 text-primary/50 flex-shrink-0 self-center"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </div>
        </div>
    )}

      </div>
    </section>


     
     <section className="relative hidden md:block">
      <div className="relative h-[60vh] lg:h-[70vh]">
        <img
          alt={ExperienceTripsDtldata?.city}
          className="absolute inset-0 w-full h-full object-cover"
          src={
            ExperienceTripsDtldata?.images
              ? `${API_BASE}${ExperienceTripsDtldata.images}`
              : `${API_BASE}default.jpg`
          }
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20" />
        <div className="absolute top-0 left-0 right-0 p-6 flex items-center justify-between z-10">
          <a href="/ExperienceTrips" className="h-10 w-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-chevron-left h-5 w-5 text-white"
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
          </a>
          <button className="h-10 w-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-share2 h-5 w-5 text-white"
            >
              <circle cx={18} cy={5} r={3} />
              <circle cx={6} cy={12} r={3} />
              <circle cx={18} cy={19} r={3} />
              <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
              <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
            </svg>
          </button>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-10 lg:p-16">
          <div className="max-w-4xl">
            <span className="inline-flex items-center gap-1.5 bg-white/95 backdrop-blur-sm text-slate-800 text-sm font-medium px-3 py-1.5 rounded-full mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-lightbulb h-4 w-4 text-primary"
              >
                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                <path d="M9 18h6" />
                <path d="M10 22h4" />
              </svg>
              {ExperienceTripsDtldata?.tage}
            </span>
            {/*<p className="text-white/70 text-base mb-2">
              12 Travelers · {ExperienceTripsDtldata?.no_of_days} Days · 1 Epic Journey
            </p>*/}
            <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              {ExperienceTripsDtldata?.name}
            </h1>
            <div className="flex flex-wrap items-center gap-4 text-white/80 text-sm">
              <span className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar h-4 w-4"
                >
                  <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                  <line x1={16} x2={16} y1={2} y2={6} />
                  <line x1={8} x2={8} y1={2} y2={6} />
                  <line x1={3} x2={21} y1={10} y2={10} />
                </svg>
                {new Date(
                    ExperienceTripsDtldata?.expdate && ExperienceTripsDtldata?.expdate !== "null"
                      ? ExperienceTripsDtldata.expdate
                      : new Date()
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
              </span>
              <span className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-clock h-4 w-4"
                >
                  <circle cx={12} cy={12} r={10} />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                {ExperienceTripsDtldata?.no_of_days} Days / {ExperienceTripsDtldata?.duration}
              </span>
              <span className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-4 w-4"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx={12} cy={10} r={3} />
                </svg>
                {ExperienceTripsDtldata?.city}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>


    {/* Modal Popup */}
{open &&
  ExperienceTripsDtldata?.local_experts_details?.length > 0 && (


        <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center">
  <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
  <div className="relative bg-white rounded-t-3xl md:rounded-3xl max-w-4xl w-full max-h-[90vh] md:max-h-[90vh] overflow-hidden shadow-2xl flex flex-col md:flex-row md:m-4">
    <button onClick={() => setOpen(false)}  className="absolute top-3 right-3 md:top-4 md:right-4 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/90 flex items-center justify-center hover:bg-white transition-colors z-10 shadow-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-x h-4 w-4 md:h-5 md:w-5 text-slate-600"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
    <div className="relative w-full md:w-2/5 flex-shrink-0">
      <div className="md:hidden flex justify-center items-start pt-4 pb-2 px-4 bg-slate-50">
        <div className="relative w-32 h-40 rounded-2xl overflow-hidden shadow-lg">
          <img
            alt={ExperienceTripsDtldata.local_experts_details[0].name}
            className="absolute inset-0 w-full h-full object-cover"
            src={`${API_BASE}/${ExperienceTripsDtldata.local_experts_details[0].profile_image}`}
          />
        </div>
      </div>
      <div className="md:hidden text-center pb-3 bg-slate-50">
        <h2 className="text-lg font-bold text-slate-900 mb-0.5">
          {ExperienceTripsDtldata.local_experts_details[0].name}
        </h2>
        {/*<p className="text-primary text-xs font-medium">
          High Altitude &amp; Adventure Expert
        </p>*/}
      </div>
      <div className="hidden md:block relative h-full min-h-[600px]">
        <img
          alt={ExperienceTripsDtldata.local_experts_details[0].name}
          className="absolute inset-0 w-full h-full object-cover"
          src={`${API_BASE}/${ExperienceTripsDtldata.local_experts_details[0].profile_image}`}
        />
      </div>
    </div>
    <div className="flex-1 p-4 md:p-8 overflow-y-auto max-h-[60vh] md:max-h-[90vh]">
      <div className="hidden md:block mb-6">
        <h2 className="text-3xl font-bold text-slate-900 mb-2">
          {ExperienceTripsDtldata.local_experts_details[0].name}
        </h2>
        {/*<p className="text-primary font-medium text-lg mb-2">
          High Altitude &amp; Adventure Expert
        </p>*/}
        <div className="flex items-center gap-2 text-slate-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-map-pin h-4 w-4"
          >
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx={12} cy={10} r={3} />
          </svg>
          <span>{ExperienceTripsDtldata.local_experts_details[0].city}, {ExperienceTripsDtldata.local_experts_details[0].state_name}</span>
        </div>
      </div>
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <a
          href={ExperienceTripsDtldata.local_experts_details[0].instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-instagram h-4 w-4"
          >
            <rect width={20} height={20} x={2} y={2} rx={5} ry={5} />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
          </svg>
          Instagram
        </a>
        <a
          href={ExperienceTripsDtldata.local_experts_details[0].facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-[#1877F2] text-white px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-facebook h-4 w-4"
          >
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
          </svg>
          Facebook
        </a>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base">
          About
        </h3>
        <p className="text-slate-600 leading-relaxed text-xs md:text-base"
                dangerouslySetInnerHTML={{
                  __html: ExperienceTripsDtldata.local_experts_details[0].about
                }}>
        </p>
      </div>
      {/*<div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe h-4 w-4 text-primary"
          >
            <circle cx={12} cy={12} r={10} />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
          Places Explored
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Ladakh
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Spiti Valley
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Zanskar
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Nepal
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Bhutan
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Tibet
          </span>
        </div>
      </div>*/}
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-languages h-4 w-4 text-primary"
          >
            <path d="m5 8 6 6" />
            <path d="m4 14 6-6 2-3" />
            <path d="M2 5h12" />
            <path d="M7 2h1" />
            <path d="m22 22-5-10-5 10" />
            <path d="M14 18h6" />
          </svg>
          Speaks
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
        {(ExperienceTripsDtldata?.local_experts_details?.[0]?.language || "")
        .split(",")
        .filter(Boolean)
        .map((lang, index) => (
          <span key={index} className="bg-blue-50 text-blue-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-blue-200">
            {lang}
          </span>
        ))}
        </div>
      </div>
      {/*<div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-gallery-horizontal h-4 w-4 text-primary"
          >
            <path d="M2 3v18" />
            <rect width={12} height={18} x={6} y={3} rx={2} />
            <path d="M22 3v18" />
          </svg>
          Gallery
        </h3>
        <div className="grid grid-cols-4 gap-2">
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 1"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/ladakh-hero-banner.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 2"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/pangong-lake-camping.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 3"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/nubra-valley-dunes.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 4"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/ladakh-monastery.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
        </div>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base">
          Expertise
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-primary/10 text-primary text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-medium">
            High Altitude
          </span>
          <span className="bg-primary/10 text-primary text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-medium">
            Adventure Expert
          </span>
          <span className="bg-slate-100 text-slate-600 text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full">
            Local Expert
          </span>
          <span className="bg-slate-100 text-slate-600 text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full">
            Verified Host
          </span>
        </div>
      </div>*/}
      <a href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 h-10 md:h-12 text-sm md:text-base font-medium">
        Book Trip with Tenzing
      </a>
    </div>
  </div>
</div>

)}

  </>

  );
};

export default ExperienceTripsDtlbanner;
